import { CdkTableModule } from "@angular/cdk/table";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatSortModule } from "@angular/material/sort";
import { LucideAngularModule } from "lucide-angular";
import { CommonTranslateModule } from "src/app/shared/utils/common-translate.module";
import { AppRoutingModule } from "../../../../app-routing.module";
import { MultipleFieldsComponent } from "../../domain/components/multiple-fields/multiple-fields.component";
import { ShapChartComponent } from "../../domain/components/shap-details/shap-chart/shap-chart.component";
import { ShapDetailsComponent } from "../../domain/components/shap-details/shap-details.component";
import { SingleFieldComponent } from "../../domain/components/single-field/single-field.component";
import { PredictionMissingDataPipe, PredictionTooltipPipe } from "../../domain/pipes/prediction.pipe";
import { BooleanLabelPipe } from "./boolean-label.pipe";
import { MetadataPageComponent } from "./metadata-page.component";

@NgModule({
  declarations: [
    MetadataPageComponent,
    PredictionTooltipPipe,
    PredictionMissingDataPipe,
    BooleanLabelPipe,
    SingleFieldComponent,
    MultipleFieldsComponent,
    ShapDetailsComponent,
    ShapChartComponent,
  ],
  providers: [],
  imports: [
    AppRoutingModule,
    CommonModule,
    CommonTranslateModule,
    FormsModule,
    ReactiveFormsModule,
    LucideAngularModule,
    CdkTableModule,
    MatSelectModule,
    MatFormFieldModule,
    MatSortModule,
  ],
})
export class MetadataPageModule {}
